<div>

  <img 
    *ngIf="content?.banner_image" 
    [src]="content.banner_image | safeValue: 'resource'" 
    alt="Module banner" 
    class="media intro_cover"
  >

  <div *ngIf="content?.intro?.length" class="intro">
    <ng-container *ngFor="let item of content?.intro">
      <ng-container class="intro" [ngTemplateOutlet]="contentBlock" [ngTemplateOutletContext]="{item: item}"></ng-container>
    </ng-container>
  </div>

  <ng-container *ngFor="let item of content?.body.body">
    <ng-container [ngTemplateOutlet]="contentBlock" [ngTemplateOutletContext]="{item: item}"></ng-container>
  </ng-container>

  <div *ngIf="content?.outro?.length" class="outro">
    <ng-container *ngFor="let item of content?.outro">
      <ng-container [ngTemplateOutlet]="contentBlock" [ngTemplateOutletContext]="{item: item}"></ng-container>
    </ng-container>
  </div>

  <div class="additional-materials_divider" 
    *ngIf="content?.body?.mind_sharpener_image_1 || content?.body?.mind_sharpener_image_2">
    <span class="p2">Additional Materials</span>
  </div>

  <div *ngIf="content?.body?.mind_sharpener_image_1" class="additional-materials_content">
    <img [src]="content?.body?.mind_sharpener_image_1 | safeValue: 'resource'" alt="" class="media">
    <app-button
      icon="download"
      [size]="'medium'"
      [style]="'outlined'"
      class="additional-materials_download" 
      (onCLick)="additional1.click()"
    ></app-button>
    <a 
      #additional1 
      [href]="content?.body?.mind_sharpener_image_1 | safeValue: 'resource'" 
      [download]="content.title + 'additional material 1'"
    ></a>
  </div>

  <div *ngIf="content?.body?.mind_sharpener_image_2" class="additional-materials_content">
    <img [src]="content?.body?.mind_sharpener_image_2 | safeValue: 'resource'" alt="" class="media">
    <app-button
      icon="download"
      [size]="'medium'"
      [style]="'outlined'"
      class="additional-materials_download" 
      (onCLick)="additional2.click()"
    ></app-button>
    <a 
      #additional2 
      [href]="content?.body?.mind_sharpener_image_2 | safeValue: 'resource'" 
      [download]="content.title + 'additional material 2'"
    ></a>
  </div>
</div>


<ng-template #contentBlock let-item="item">
  <ng-container [ngSwitch]="item?.type">
    <div *ngSwitchCase="types.HEADING" class="content-wrap">
      <h2>{{item.value}}</h2>
    </div>
    <div *ngSwitchCase="types.PARAGRAPH" [innerHtml]="item.value | safeValue: 'html'" class="content-wrap"></div>
    <div *ngSwitchCase="types.QUOTATION" class="content-wrap">
      <span>{{item.value?.quote}}</span>
      <span>{{item.value?.author}}</span>
    </div>
    <!-- <div *ngSwitchCase="types.IMAGE" class="padding-bottom"> -->
      <!-- FIXME: there is id of picture, need find a way to get i=mg url-->
      <!-- <img [src]="item.value | safeValue: 'resource'" alt="" class="media"> -->
    <!-- </div> -->
    <div *ngSwitchCase="types.VIDEO" class="padding-bottom">
      <ng-container *ngIf="getVideoData(item.value?.video) | async as video; else loader">
        <video 
          #videoplayer
          preload="metadata"
          crossorigin="use-credentials"
          controls
          [poster]="video.thumbnail | safeValue: 'resource'"
          class="media"
          [attr.id]="video.id"
        >
          <source [src]="video.file | safeValue: 'resource'" type="video/mp4" />
          Sorry, your browser doesn't support embedded videos.
        </video>
        <span 
          *ngIf="item.value?.description" 
          class="description p5"
        >{{item.value?.description}}</span>
      </ng-container>
    </div>

    <div *ngSwitchDefault class="content-wrap"></div>
  </ng-container>
</ng-template>

<ng-template #loader>
  <app-spinner class="list-loader"></app-spinner>
</ng-template>